// The saved placeholder tags configured on Settings -> Placeholders. Shared by
// the AI Response node and the email node so both offer the same set for
// insertion. Kept in sync with PlaceholdersTab.tsx.
export const PLACEHOLDER_FIELDS: { tag: string; label: string }[] = [
  { tag: "companyName", label: "Company name" },
  { tag: "agentName", label: "Agent name" },
  { tag: "agentPhone", label: "Phone number" },
  { tag: "agentEmail", label: "Email" },
  { tag: "referralGift", label: "Referral gift" },
  { tag: "efsName", label: "Financial Specialist name" },
  { tag: "efsPhone", label: "Financial Specialist phone" },
  { tag: "efsEmail", label: "Financial Specialist email" },
  { tag: "efsBio", label: "Financial Specialist bio" },
];

export type PlaceholdersResponse = Record<string, string | null>;

// tag -> saved value, only for tags the user has actually filled in. These are
// the only ones offered for insertion and the values rendered inside chips.
export const buildPlaceholderValues = (
  placeholders: PlaceholdersResponse
): Record<string, string> => {
  const map: Record<string, string> = {};
  PLACEHOLDER_FIELDS.forEach((f) => {
    const v = (placeholders[f.tag] ?? "").toString();
    if (v.trim()) map[f.tag] = v;
  });
  return map;
};
